import { useTranslations } from "next-intl";

import * as Dialog from "@/components/dialog/DialogLayout";

export const ConfirmDialog = ({
  title,
  description,
  isOpen = false,
  isLoading = false,
  onConfirm,
  onClose,
}: {
  title: React.ReactNode;
  description?: string;
  isOpen: boolean;
  isLoading: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) => {
  const t = useTranslations();

  return (
    <Dialog.Root open={isOpen} onClose={onClose}>
      <Dialog.Backdrop />
      <Dialog.Container>
        <Dialog.Panel className="max-w-[440px] min-w-[250px]">
          {description ? (
            <>
              <Dialog.Title className="mr-10">{title}</Dialog.Title>
              <p className="mt-2 mb-0 text-gray-600 dark:text-gray-400 text-[15px] leading-[18px]">
                {description}
              </p>
            </>
          ) : (
            <Dialog.Title className="mr-10 font-normal text-size-16 mb-2">{title}</Dialog.Title>
          )}
          <Dialog.Footer>
            <Dialog.Button isBusy={isLoading} variant="accent" onClick={onConfirm}>
              {t("dialog.confirm")}
            </Dialog.Button>
            <Dialog.Button variant="outline" onClick={onClose}>
              {t("dialog.cancel")}
            </Dialog.Button>
          </Dialog.Footer>
          <Dialog.CloseButton>
            <Dialog.CloseIcon />
          </Dialog.CloseButton>
        </Dialog.Panel>
      </Dialog.Container>
    </Dialog.Root>
  );
};
